import Vue from 'vue'
import Vuex from 'vuex'
import { decode } from 'jsonwebtoken'
import Cookies from 'js-cookie'

import actions from './actions'

const token = Cookies.get('auth_token')
const name = Cookies.get('name')
const store_url = Cookies.get('store_url')
const email = Cookies.get('email')
const channel_id = Cookies.get('channel_id')
const seller_type = Cookies.get('seller_type')
const store_channelid = Cookies.get('store_channelid')
const is_storeactive = Cookies.get('is_storeactive')

const getExpireIn = token => {
  if (!token) return null

  const jwt = decode(token)

  return jwt ? jwt.exp : 0
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    id: '',
    name: name,
    role: null,
    email: email,
    avatar: '',
    accessToken: token,
    expireIn: getExpireIn(token),
    loading: false,
    profile: null,
    loginResponse: {
      code: 0,
      message: '',
    },
    confirmpass: {
      link: '',
      token: '',
    },
    register_id: null,
    base_url: '',
    wallet: 0,
    currency: '',
    store_url: store_url,
    is_storeactive: is_storeactive,
    channel_id,
    seller_type,
    store_channelid,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
    LOGIN(state, { token, profile = {}, store_url, name, email, channel_id, seller_type, store_channelid, is_storeactive }) {
      state.accessToken = token
      state.profile = profile
      state.expireIn = getExpireIn(token)
      state.channel_id = channel_id
      state.seller_type = seller_type
      state.store_channelid = store_channelid
      state.is_storeactive = is_storeactive

      Cookies.set('auth_token', token)
      Cookies.set('store_url', store_url)
      Cookies.set('name', name)
      Cookies.set('email', email)
      Cookies.set('channel_id', channel_id)
      Cookies.set('seller_type', seller_type)
      Cookies.set('store_channelid', store_channelid)
      Cookies.set('is_storeactive', is_storeactive)
    },
    LOGOUT(state) {
      state.accessToken = null
      state.expireIn = null
      state.profile = null
      state.id = null
      state.email = null
      state.name = null
      state.role = null
      state.wallet = 0
      state.currency = null
      state.store_url = null
      state.is_storeactive = null
      state.store_channelid = null

      Cookies.remove('auth_token')
      Cookies.remove('store_url')
      Cookies.remove('name')
      Cookies.remove('email')
      Cookies.remove('ewallet')
      Cookies.remove('channel_id')
      Cookies.remove('seller_type')
      Cookies.remove('store_channelid')
      Cookies.remove('is_storeactive')
    },
    CLEAR_LOGIN(state) {
      Object.assign(state, {
        loginResponse: {
          code: 0,
          message: '',
        },
      })
    },
    SET_DATA_RESET_PASSWORD (state, payload) {
      const { link, token } = payload
      state.confirmpass.link = link
      state.confirmpass.token = token
    },
  },
  actions,
  getters: {
    user: state => state,
    loginStatusCode: state => state.loginResponse.code,
    expireIn: state => getExpireIn(state.accessToken),
    seller_type: state => state.seller_type,
    user_email: state => state.email,

    sellerType: state => state?.seller_type,
    isDropship: (_, getter) => getter.sellerType === 'dropship',
    isDistributor: (_, getter) => getter.sellerType === 'distributor',

    authorized: (state) => {
      return !!state.accessToken
    },
  },
}
